module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Конфіденційність",
	"footer.privacy.url": "https://www.grohe.ua/uk_ua/kompanija/novosti/bezopasnost.html",
	"footer.disclaimer.text": "Правова інформація",
	"footer.disclaimer.url": "https://www.grohe.ua/uk_ua/kompanija/novosti/juridicheskaja-infomracija.html",
	"footer.copyright": "&copy; 2017 GROHE AG",
	"homepage.headline": "Конфігуратор душових систем GROHE",
	"homepage.introtext": "Дайте відповіді на декілька запитань, щоб скомпонувати душову систему GROHE SmartControl, яка відповідатиме вашим потребам.",
	"homepage.buttonStart": "Розпочати",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Сторінку не знайдено",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "Дивитися результат",
	"question1.question": "У якому місці Вашої ванної кімнати Ви  плануєте розмістити душ? ",
	"question1.option1.text": "У душовій",
	"question1.option2.text": "У ванній, включаючи вилив на ванну",
	"question2.question": "Якому виду монтажу Ви надаєте перевагу - зовнішньому,  прихованому чи напівприхованому?",
	"question2.option1.text": "Зовнішньому монтажу: просте рішення для оновлення на стіні, яке не вимагає жодних зусиль",
	"question2.option2.text": "Комбінованому  монтажу: приховані за стіної труби і видимий термостат із поличкою на стіні",
	"question2.option3.text": "Прихованому монтажу: мінімалізм завдяки прихованим за стіною технологіям",
	"question3.question": "Якому типу керування душем Ви надаєте перевагу?",
	"question3.option1.text": "За допомогою системи SmartControl і термостата",
	"question3.option2.text": "Стандартному і за допомогою  термостата",
	"question3.option3.text": "За допомогою одноважільного змішувача",
	"question3.option4.text": "За допомогою перемикача настінного монтажу (зберігаючи при цьому існуючий змішувач)",
	"question4.question": "Якими елементами Ви б хотіли керувати за допомогою душу?",
	"question4.option1.text": "Лише ручним душем",
	"question4.option2.text": "Великим верхнім душем (150-250 мм) і ручним душем",
	"question4.option3.text": "Надвеликим верхнім душем (250-400 мм) і ручним душем",
	"question4.option4.text": "Великим верхнім душем (150-250 мм), ручним душем і виливом на ванну",
	"question4.option5.text": "Надвеликим верхнім душем (250-400 мм), ручним душем і виливом на ванну",
	"question5.question": "Якій формі Ви надаєте перевагу?",
	"question5.option1.text": "Квадрат",
	"question5.option2.text": "Круг",
	"question6.question": "Якими складовими душу Ви б хотіли керувати за допомогою SmartControl?",
	"question6.option1.text": "Верхнім душем з двома режимами струменю і ручним душем",
	"question6.option2.text": "Верхнім душем з двома режимами струменю і ручним душем",
	"question6.option3.text": "Верхнім, ручним душами і змішувачем на ванну",
	"question6.option4.text": "Верхнім, двома боковими і ручним душами",
	"question6.option5.text": "Верхнім та ручним душем",
	"question6.option6.text": "Ручним душем і змішувачем на ванну",
	"question6.option7.text": "Лише ручним душем",
	"question6.option8.text": "Лише змішувачем на ванну",
	"question7.question": "Оберіть колір",
	"question7.option1.text": "Хром",
	"question7.option2.text": "Білий/Хром",
	"question7.option3.text": "Білий/Хром",
	"question8.question": "Ви б хотіли термостат із вбудованим тримачем для душу?",
	"question8.option1.text": "Ні, я куплю окремий тримач для ручного душу",
	"question8.option2.text": "Так, із вбудованим тримачем для душу",
	"question9.question": "Як Ви б хотіли кріпити свій ручний душ?",
	"question9.option1.text": "За допомогою тримача, вбудованого у душовий кронштейн, з можливістю регулювання по висоті",
	"question9.option2.text": "За допомогою душового тримача у стилі мінімалізм",
	"question10.question": "Ви надаєте перевагу верхньому душу з настінним чи настельним монтажем?",
	"question10.option1.text": "З настінним монтажем",
	"question10.option2.text": "З настельним монтажу",
	"results.title": "{productGroupsCount, plural, \none {Ваш результат} \nother {Ваші результати}\n}",
	"results.proposal.title": "Пропозиція {number}",
	"results.proposal.title.single": "ПРОПОЗИЦІЯ",
	"results.bundle.title": "Для правильного проведення монтажу Вам також знадобляться:",
	"results.newConfiguration.title": "Хотіли б скомпонувати нову душову систему?",
	"results.newConfiguration.buttonText": "Розпочати новий підбір",
	"results.product.number": "Артикул: #{number}",
	"results.product.button.productInformation": "Інформація про продукт",
	"results.product.button.dealerLocator": "Знайти салон-магазин",
	"results.product.button.buyNow": "Купити онлайн",
	"results.product.button.downloadPDF": "Завантажити пропозицію (PDF)",
	"results.product.information": "Інформація про продукт",
	"results.product.dealer": "Знайти салон-магазин",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/shower.uk_ua.json
// module id = 760
// module chunks = 0